import { InferSelectModel } from 'drizzle-orm';
import { index, pgTable, serial, timestamp, unique } from 'drizzle-orm/pg-core';

import { createPubkeyField } from './utils';

/**
 * This table stores the mapping between authority (connected wallet) and their Privy embedded wallet.
 * This allows tracking which Privy embedded wallet belongs to which authority, but should not necessarily
 * be used as the source of truth for the embedded wallet mapping.
 * Ultimately, the source of truth is the Privy user object.
 */
export const privy_wallet_mappings = pgTable(
	'privy_wallet_mappings',
	{
		id: serial('id').primaryKey(),

		authority: createPubkeyField('authority').notNull(),

		embeddedWallet: createPubkeyField('embeddedWallet').notNull(),

		insertedTime: timestamp('insertedTime', { withTimezone: true })
			.notNull()
			.defaultNow(),

		updatedTime: timestamp('updatedTime', { withTimezone: true })
			.notNull()
			.defaultNow(),
	},
	(t) => {
		return {
			authorityIdx: index('privy_wallet_mappings_authority_idx').on(
				t.authority
			),
			authorityUnique: unique('privy_wallet_mappings_authority_unique').on(
				t.authority
			),
		};
	}
);

export type PrivyWalletMapping = InferSelectModel<typeof privy_wallet_mappings>;
